const host = 'https://staging.universe.com';

export default {
  api: {
    base: `${host}/api/v2`,
    host,
  },
  googleMapsApiKey: 'AIzaSyD3q6LYn2E79CCBR1g_NG3NbdK8IFPN2g8',
  uploadcare: {
    key: '6983c6f19fcba1adfe3d',
  },
  images: {
    url: 'https://images.universe.com/',
  },
  amplitude: {
    key: '6dff3aa1ddb0eedffcc73805cd59a65a',
  },
  environment: 'staging',
  sentryDsn: 'https://c9e0e678a3a14ef3884b41ac1ed8ec91@sentry.io/1529844',
  gtm: '',
  supersetUrl: 'https://dashboards.staging.universe.com',
  grpcGatewayUrl: "https://staging.universe.com/reports-service",
  zenithSupersetUrl: 'https://dashboards.staging.universe.com',
  zenithSupersetGatewayUrl: 'https://staging.universe.com/superset-embed-gateway',
  faro: {
    url: 'https://collector.us-east4.staging.universe.engineer/collect',
  },
  flipt: {
    namespace: 'default',
    options: {
      url: 'https://flags.us-east4.staging.universe.engineer/'
    }
  }
};
